<script setup>
import { computed } from 'vue';

const props = defineProps({
  suggestion: {
    type: Object,
    required: true,
  },
});

const confidenceColor = computed(() => {
  switch (props.suggestion.confidence?.toUpperCase()) {
    case 'HIGH':
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
    case 'MEDIUM':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
    case 'LOW':
      return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200';
    default:
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
  }
});

const confidenceIcon = computed(() => {
  switch (props.suggestion.confidence?.toUpperCase()) {
    case 'HIGH':
      return '✓';
    case 'MEDIUM':
      return '~';
    case 'LOW':
      return '!';
    default:
      return '?';
  }
});
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-center gap-2 min-w-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-4 h-4 text-purple-600 dark:text-purple-400 flex-shrink-0"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
        />
      </svg>
      <p
        class="max-w-full min-w-0 overflow-hidden text-sm font-medium text-n-slate-11 text-ellipsis whitespace-nowrap"
      >
        {{ suggestion.text }}
      </p>
    </div>
    <div class="flex items-center gap-1.5 pl-6">
      <span
        class="inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-[0.625rem] font-medium"
        :class="confidenceColor"
      >
        <span class="font-bold">{{ confidenceIcon }}</span>
        <span class="uppercase tracking-wide font-semibold">{{
          suggestion.confidence
        }}</span>
      </span>
      <div class="flex flex-wrap items-center gap-1">
        <span
          v-for="kb in suggestion.knowledgebases_used"
          :key="kb"
          class="inline-flex items-center px-1.5 py-0.5 rounded text-[0.625rem] font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200"
        >
          {{ kb }}
        </span>
      </div>
    </div>
  </div>
</template>
